import React, { useRef } from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { GrFormNext, GrFormPrevious } from "react-icons/gr";
import paidLogo from "../../../../Asset/mobileApp/paid-logo-img.png";
import paidimg from "../../../../Asset/mobileApp/paid-768x1003.png";
import meshaLogo from "../../../../Asset/mobileApp/mesha-logo-img.png";
import meshaimg from "../../../../Asset/mobileApp/messa-768x1003.png";
import wellLogo from "../../../../Asset/mobileApp/welness-logo-img.png";
import wellimg from "../../../../Asset/mobileApp/welness-768x1003.png";
import "./Fifth.css";

const portfolioData = [
  {
    logo: paidLogo,
    image: paidimg,
    title: "Paid - B2B Business Solution",
    description:
      "Paid is a B2B Ultimate Business solution and payment platform...",
    domain: "Fintech | E-commerce",
    downloads: "75T+",
  },
  {
    logo: meshaLogo,
    image: meshaimg,
    title: "Mesha - Group investing for all",
    description:
      "A social investing app where users can chat, invest in stocks...",
    domain: "NFT Marketplace",
    downloads: "10T+",
  },
  {
    logo: wellLogo,
    image: wellimg,
    title: "Welnes - Nutrition & Fitness",
    description: "Welnes offers personalized home workout and diet plans...",
    domain: "Fintech",
    downloads: "50T+",
  },
];

const Fifth = () => {
  const sliderRef = useRef(null);
  const navigate = useNavigate();

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 400,
    autoplaySpeed: 5000,
    cssEase: "linear",
  };

  return (
    <section className="fifth-mobileApp-section">
      <Container>
        <div className="top-text-after-fifth-mobileApp">
          <h2>
            OUR BEST <span>PORTFOLIO PIECES</span>
          </h2>
        </div>
        <div className="slider-container">
          <Slider ref={sliderRef} {...settings}>
            {portfolioData.map((item, index) => (
              <div key={index} className="portfolio-details-slide">
                <div className="scroll-card-wrapper">
                  <div className="row">
                    <div className="col-sm-6 col-12">
                      <div className="card-logo">
                        <img src={item.logo} alt={item.title} />
                      </div>
                      <h3>{item.title}</h3>
                      <p className="mb-3">{item.description}</p>
                      <div className="portfolio-detail d-flex">
                        <div className="business-domain">
                          <p>Business Domain</p>
                          <h6>{item.domain}</h6>
                        </div>
                        <div className="business-domain">
                          <p>Downloads</p>
                          <h6>{item.downloads}</h6>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary-outline btn-portfolio"
                        onClick={() => navigate("/portfolio")}
                      >
                        Explore More
                      </button>
                    </div>
                    <div className="col-sm-6 col-12 text-center">
                      <div className="scroll-img-card">
                        <img src={item.image} alt={item.title} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
          <div className="splide__arrows">
            <button
              className="splide__arrow splide__arrow--prev"
              onClick={() => sliderRef.current.slickPrev()}
            >
              <GrFormPrevious className="svg" />
            </button>
            <button
              className="splide__arrow splide__arrow--next"
              onClick={() => sliderRef.current.slickNext()}
            >
              <GrFormNext className="svg" />
            </button>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Fifth;
